module.exports = __webpack_public_path__ + "media/images/favicon/mstile-70x70-b2fcf89ae9bd5b34e73f2f80218c2892.png";